type ColorPair = {
  readonly background: string;
  readonly foreground: string;
};

const colorPalette: NonEmptyArray<ColorPair> = [
  {
    background: '#6D1313',
    foreground: '#fff',
  },
  {
    background: '#4161C4',
    foreground: '#fff',
  },
  {
    background: '#63E987',
    foreground: '#000',
  },
  {
    background: '#F1D67E',
    foreground: '#000',
  },
  {
    background: '#F17E7E',
    foreground: '#000',
  },
  {
    background: '#86B1CB',
    foreground: '#000',
  },
  {
    background: '#67964D',
    foreground: '#000',
  },
  {
    background: '#947DF7',
    foreground: '#000',
  },
  {
    background: '#D2A7CF',
    foreground: '#000',
  },
  {
    background: '#9B1772',
    foreground: '#fff',
  },
];

const colorCount = colorPalette.length;

export const getColorsFromPalette = (index: number): ColorPair => {
  return colorPalette[index % colorCount] ?? colorPalette[0];
};
